function toIsoDate(value: Date) {
  return value.toISOString().slice(0, 10);
}

function toDateOnly(value: Date) {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate());
}

function isPastDate(value: Date) {
  return toDateOnly(value) < toDateOnly(new Date());
}

function isPastDateTime(value: Date) {
  return dateToPrimitive(value) < Date.now();
}

function dateToPrimitive(value: Date) {
  return value.getTime();
}

function withoutSeconds(value: Date) {
  const newValue = new Date(value);
  newValue.setSeconds(0, 0);

  return newValue;
}

export { dateToPrimitive, isPastDate, isPastDateTime, toDateOnly, toIsoDate, withoutSeconds };
